import Vue from "vue";
import Qs from "qs";
import VueRouter from "vue-router";

window.Vue = Vue;
Vue.use(VueRouter);

import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import api from "./http/index";
import menuUtil from "./utils/index";
import "./directive/directives";
import url from "./interface/url";
import toolUtil from "./utils/toolUtil";
import timeUtil from "./utils/timeUtil";
import "./assets/icon/iconfont.css";
import VueScroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import md5 from "js-md5";
import permission from "./directive/permission";
import cloud from "./utils/cloud";
import message from "./utils/message";
import method from "./interface/method";
import i18n from "./utils/i18n";
import Clipboard from "v-clipboard";
import tools from "./utils/tools";
import eventBus from "./utils/eventBus";
import "@/utils/default-passive-events.js";
//  富文本编辑器
import { ElementTiptapPlugin } from "element-tiptap";
// 引入 ElementUI
import ElementUI from "element-ui";
// 引入 ElementUI 样式
import "element-ui/lib/theme-chalk/index.css";
// 引入 ElementUI 英文语言包
import ElementLocale from "element-ui/lib/locale/lang/en";
// 引入 import element-tiptap 样式
import "element-tiptap/lib/index.css";
import "animate.css";
// 安装 element-tiptap 插件
Vue.use(ElementTiptapPlugin, {
  lang: "en" // 设置语言为英文
});
// 安装 ElementUI 并设置语言为英文
Vue.use(ElementUI, { locale: ElementLocale });
Vue.use(permission);

Vue.config.productionTip = false;
Vue.use(store);
Vue.use(VueScroll);
Vue.use(Clipboard);
Vue.prototype.$vuescrollConfig = {
  bar: {
    size: "4px",
    hoverStyle: true, // 移入鼠标就显示滚动条
    onlyShowBarOnScroll: false, // 是否只有滚动的时候才显示滚动条
    background: "hsla(220,4%,58%,.3)"
  }
};
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);

Vue.prototype.$method = method;

Vue.use(api);
Vue.prototype.$qs = Qs;
Vue.prototype.$url = url;
Vue.prototype.$toolUtil = toolUtil;
Vue.prototype.$timeUtil = timeUtil;
Vue.prototype.$md5 = md5;
Vue.prototype.$cloud = cloud;
Vue.prototype.$message = message;
Vue.prototype.$tools = tools;
Vue.prototype.$eventBus = eventBus;

router.beforeEach((to, _from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else if (to.name) {
    document.title = to.name;
  }
  if (to.path === "/login") {
    next();
  } else {
    if (store.state.token) {
      if (to.path === "/") {
        router.push("/main");
      } else {
        menuUtil.initMenu(router, store);
        next();
      }
    } else {
      router.push("/login");
    }
  }
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
